module.exports = __webpack_public_path__ + "static/staffy-logo-7b0a472ce52b3d9cc6aafd206fc85668.jpg";